var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card-footer',[_c('b-navbar',[_c('b-navbar-nav',{staticClass:"ml-auto"},[_vm._v("Количество записей: "),_c('b',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.count))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }